<template>
    <template v-if="data.children">
        <div class="menu-item expandable" :class="{expanded, open}">
            <div class="item-content" @click="toggle">
                <!-- <MenuIcon class="icon" :id="id"/> -->
                <div class="label">{{$t(data.label)}}</div>
                <div class="expand">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                      <g transform="translate(-952.5 -488.5)">
                        <path class="vertical" d="M14,1a.936.936,0,0,1-.875,1H.875A.936.936,0,0,1,0,1,.955.955,0,0,1,.875,0h12.25A.936.936,0,0,1,14,1Z" transform="translate(960.5 488.5) rotate(90)"/>
                        <path class="horizontal" d="M14,16.4a.936.936,0,0,1-.875,1H.875A.936.936,0,0,1,0,16.4a.955.955,0,0,1,.875-1h12.25A.936.936,0,0,1,14,16.4Z" transform="translate(952.5 479.1)"/>
                      </g>
                    </svg>
                </div>
            </div>
            <div class="children" v-if="expanded">

                <template v-for="(item,id) in data.children" :key="`menu-item-${id}`" >
                    <router-link  class="child-item" v-if="canBeSeen(item) === 'true'" :to="item.route">
                        <span  >  {{$t(item.label)}} </span>
                    </router-link>
                </template>
            </div>
        </div>
    </template>

    <router-link v-else class="menu-item" :class="{open}" :to="data.route">
        <div class="item-content">
            <!-- <MenuIcon class="icon" :id="id"/> -->
            <div class="label">{{ $t(data.label) }}</div>
            <NotificationsBadge :counter="data.notifications"/>
        </div>
    </router-link>
</template>

<script>
// import MenuIcon from '@/components/core/MenuIcon.vue'
import NotificationsBadge from '@/components/core/NotificationsBadge.vue'
import { mapGetters} from 'vuex'
export default {
    name: 'MenuItem',
    data(){ return {
        expanded: false
    }},
    props: {
        id: String,
        data: Object
    },
    components: {
        // MenuIcon,
        NotificationsBadge
    },
    computed: {
        ...mapGetters(['isDevEnv']),
        open(){
            return this.$store.state.system.menuOpen
        }
    },
    methods: {
        toggle(){
            this.expanded = !this.expanded
        },
        canBeSeen(item){
            if(item.devOnly){
                return this.isDevEnv
            }else{
                return 'true'
            }
        }
    }
}
</script>

<style lang="css" scoped>
.menu-item {
    display: block;
    padding: 11px 29px 11px 32px;
    font-size: 20px;
    line-height: 26px;
    transition: all 0.2s ease;
}
.item-content {
    display: flex;
}
.item-content .label {
    font-weight: bold;
}
.children {
    margin-left: 15px;
    margin-top: 16px;
    display: flex;
    flex-flow: column;
}
.child-item {
    color: #2C3536;
    font-size: 14px;
    line-height: 20px;
    font-weight: normal;
    padding-top: 7px;
    padding-bottom: 7px;
}
.child-item:last-of-type {
    margin-bottom: -7px;
}
.expandable .item-content {
    cursor: pointer;
}
.expand svg {
    display: block;
    transition: all 0.2s ease-in-out;
}
.expand {
    display: block;
    margin-left: auto;
    margin-right: 9px;
    position: relative;
    top: 6px;
}
.expanded .expand svg {
    transform: rotate(-90deg);
}
.expand .horizontal {
    transition: fill 0.15s ease;
}
.expanded .expand .horizontal {
    fill: transparent;
}
.menu-item,
.menu-item.expandable .item-content,
.child-item {
    transition: all 0.2s ease;
}
a.menu-item:hover,
.menu-item.expandable .item-content:hover,
.child-item:hover {
    text-decoration: none;
    color: #E77423;
}
.icon {
    display: none;
}
@media (min-width: 768px) {
    .menu-item {
        font-weight: bold;
        width: 100%;
        display: block;
        padding: 11px 20px 11px 32px;
    }
    .menu-item:last-of-type {
        border-bottom: none;
    }
    .expand {
        display: block;
    }
    .expanded .children {
        display: flex;
    }

    .router-link-active {
        color: #E77423;
    }
}
</style>
